import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, } from 'react-router-dom';
import { toast } from 'react-toastify';
import queryString  from 'query-string';
import Flex from './../../../common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ResetPwdForm  from './resetPwdForm';
import {validateResetPwdToken, changePassword} from './../../../../actions/authAction'
import withAuthSplit from './../../../../hoc/withAuthSplit';
import bgImg from './../../../../assets/img/generic/21.jpg';
import { Button, Col, Row, Spinner } from 'reactstrap';

const ResetPwd = (props) => {
    const { setBgProps }=props;
    const location =useLocation();
    const [loading, setLoading]=useState(false);
    const [validToken,setValidToken]=useState(undefined);
    useEffect(() => setBgProps({ image: bgImg, position: '50% 20%' }), [setBgProps]);
    useEffect(()=>{
        validateToken();
    },[]);

    const validateToken=async()=>{
        console.log(location );
        const {token, uid}=queryString.parse(location.search);;
        await setLoading(true);        
        const result=await validateResetPwdToken({token,uid});
        await setLoading(false);
        if(!result.error){
            const {data}=result;
            if((data||false)===false){                
                setValidToken(false);
            }else{
                setValidToken(true);
            }
        }else{
            toast.error(result.errorMessage);
            props.history.push('/404');
        }
    }
    const invalidTokenPan=()=>{
        return <Row className="justify-content-between align-items-center">
                    <Col xs="12">
                        <label className='text-danger text-center fs-1'>
                            <FontAwesomeIcon icon="exclamation-circle" transform="shrink-3" /> Your registration link has expired please contact your system administrator.
                        </label>
                    </Col>
                </Row>
    }
    const onSubmit=async(data)=>{
        const {history}=props;
        const {token, uid}=queryString.parse(location.search);
        const reqObj={
            username: uid,
            fToken: token,
            password: data.password,
            isCaterer: true}
        const resp=await changePassword(reqObj);
        if(!resp.error){
            toast.success('Your password has been set successfully.');
            history.push('/login');
        }else{
            toast.error(resp.errorMessage);
        }
    }
    const onCancelClick=()=>{
        const {history}=props;
        history.push('/login');
    }
  return (
    <Fragment>
      <Flex align="center" justify="center">
        <h3>Reset Password</h3>
      </Flex>
      {
        validToken===true?<ResetPwdForm layout="split" hasLabel {...{loading,onSubmit, onCancelClick}} />:
        validToken===false?invalidTokenPan():
        <Row>
            <Col className='text-center'>
                <Button color="primary"
    disabled>
                <Spinner size="sm" >
                Loading...
                </Spinner><span>
      {' '}Loading
    </span>
                </Button>
            </Col>
        </Row>
            
      }
        
    </Fragment>
  );
};

ResetPwd.propTypes = { setBgProps: PropTypes.func.isRequired };

export default withAuthSplit(ResetPwd);
